import React from 'react';
import PropTypes from 'prop-types';
import chatIcon from '../../assets/icons/Chat.svg';
import phoneIcon from '../../assets/icons/Phone.svg';
import emailIcon from '../../assets/icons/Email.svg';
import {
  GetInTouchTitle, GetInTouchContainer, GetInTouchContactsContainer, GetInTouchFieldsContainer,
  GetInTouchContactLine, GetInTouchContactsTitle, GetInTouchContactsText, GetInTouchContactsIcon,
  EmptyLine, GetInTouchPane, ChatLinkContainer, GetInTouchContactEmailLine, GetInTouchTruckloadEmailsContactsText,
} from './css';
// import freightSalesForceChat from '../ReactComponent/ChatWindow/freightSalesForceChat';
// import samedaySalesForceChat from '../ReactComponent/ChatWindow/samedaySalesForceChat';
import SalesForceChat from '../ReactComponent/ChatWindow/SalesForceChat';
import { Locales, SalesforceChatLanguages } from '../../utils/enums';

export const GetInTouchReasonType = {
  CustomerCare: 'customer-care',
  Sales: 'sales',
  MediaInquiries: 'media-inquiries',
};

const GetInTouch = (props) => {
  const { cmsFields } = props;
  const {
    contactsTruckloadTitle,
    contactsTruckloadPhone,
    contactsTruckloadEmail,
    contactsCommerceSolutionsTitle,
    contactsCommerceSolutionsPhone,
    contactsCommerceSolutionsEmail,
    contactsFlatBedTitle,
    contactsFlatBedEmail,
    contactsSalesInquireiesTitle,
    contactsSalesInquiriesEmail,
    contactsGeneralInquiriesSubmitQuery,
    contactsGeneralInquiriesTitle,
    contactsLogisticsTitle,
    // contactsLogisticsPhone,
    contactsLogisticsEmail,
    contactsWebsiteSupportTitle,
    contactsWebsiteSupportEmail,
    contactsBeginChatText,
    billingInquiriesTitle,
    billingInquiriesEmail,
    billingInquiriesPhone,
    contactsLTLTruckloadTitle,
    contactsLogisticsWest,
    contactsLogisticsCentral,
    contactsLogisticsEast,
    contactsLogisticsAtlantic,
    contactsLogisticsIntermodal,
  } = cmsFields;

  const getCMSFieldValue = (field) => (field ? field.value : null);

  const renderChatLine = ({ onClick }) => (
    <ChatLinkContainer onClick={onClick}>
      <GetInTouchContactsIcon $mobile={2}><img src={chatIcon} alt="chat" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(contactsBeginChatText)}</GetInTouchContactsText>
    </ChatLinkContainer>
  );

  const renderPhoneLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={phoneIcon} alt="phone" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  const renderCommerceEmailLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={emailIcon} alt="email" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  const renderLTLEmailLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={emailIcon} alt="email" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  const renderLogisticsEmailLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={emailIcon} alt="email" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  const renderLogisticsWestLine = (field) => (
    <GetInTouchContactEmailLine>
      <GetInTouchTruckloadEmailsContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchTruckloadEmailsContactsText>
    </GetInTouchContactEmailLine>
  );

  const renderLogisticsCentralLine = (field) => (
    <GetInTouchContactEmailLine>
      <GetInTouchTruckloadEmailsContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchTruckloadEmailsContactsText>
    </GetInTouchContactEmailLine>
  );

  const renderLogisticsEastLine = (field) => (
    <GetInTouchContactEmailLine>
      <GetInTouchTruckloadEmailsContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchTruckloadEmailsContactsText>
    </GetInTouchContactEmailLine>
  );

  const renderLogisticsAtlanticLine = (field) => (
    <GetInTouchContactEmailLine>
      <GetInTouchTruckloadEmailsContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchTruckloadEmailsContactsText>
    </GetInTouchContactEmailLine>
  );

  const renderLogisticsIntermodalLine = (field) => (
    <GetInTouchContactEmailLine>
      <GetInTouchTruckloadEmailsContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchTruckloadEmailsContactsText>
    </GetInTouchContactEmailLine>
  );

  const renderFlatBedEmailLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={emailIcon} alt="email" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  const renderSalesInquiriesEmailLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={emailIcon} alt="email" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  const renderSubmitQueryEmailLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={emailIcon} alt="email" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  const renderWebsiteSupportEmailLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={emailIcon} alt="email" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  const renderBillingEnquiriesEmailLine = (field) => (
    <GetInTouchContactLine>
      <GetInTouchContactsIcon $mobile={2}><img src={emailIcon} alt="email" /></GetInTouchContactsIcon>
      <GetInTouchContactsText $mobile={10}>{getCMSFieldValue(field)}</GetInTouchContactsText>
    </GetInTouchContactLine>
  );

  // eslint-disable-next-line arrow-body-style
  const renderCustomerCareContacts = () => {
    return (
      <div>
        {/*  Commerce Solutions  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(contactsCommerceSolutionsTitle)}</GetInTouchContactsTitle>
        {renderPhoneLine(contactsCommerceSolutionsPhone)}
        {renderChatLine({
          onClick: () => SalesForceChat().showChatWindow(
            window.location.pathname.toLowerCase().includes(`/${Locales.French.toLowerCase()}/`)
              ? SalesforceChatLanguages.French
              : SalesforceChatLanguages.English,
          ),
        })}
        <a href="mailto:commercesolutions@dayross.com">{renderCommerceEmailLine(contactsCommerceSolutionsEmail)}</a>
        <EmptyLine />

        {/*  LTL  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(contactsTruckloadTitle)}</GetInTouchContactsTitle>
        {renderPhoneLine(contactsTruckloadPhone)}
        {renderChatLine({
          onClick: () => SalesForceChat().showChatWindow(
            window.location.pathname.toLowerCase().includes(`/${Locales.French.toLowerCase()}/`)
              ? SalesforceChatLanguages.French
              : SalesforceChatLanguages.English,
          ),
        })}
        <a href="mailto:custservice@dayandrossinc.ca">{renderLTLEmailLine(contactsTruckloadEmail)}</a>
        <EmptyLine />

        {/*  Truckload  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(contactsLTLTruckloadTitle)}</GetInTouchContactsTitle>
        {/* {renderTruckloadPhoneLine(contactsLTLTruckloadPhone)} */}
        <a href="mailto:drtruckload@dayandrossinc.ca">{renderLTLEmailLine(contactsTruckloadEmail)}</a>
        <EmptyLine />

        {/*  Logistics  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(contactsLogisticsTitle)}</GetInTouchContactsTitle>
        <span>{renderLogisticsEmailLine(contactsLogisticsEmail)}</span>
        <a href="mailto:Logistics.West@dayross.com">{renderLogisticsWestLine(contactsLogisticsWest)}</a>
        <a href="mailto:Logistics.Central@dayross.com">{renderLogisticsCentralLine(contactsLogisticsCentral)}</a>
        <a href="mailto:Logistics.East@dayross.com">{renderLogisticsEastLine(contactsLogisticsEast)}</a>
        <a href="mailto:Logistics.Atlantic@dayross.com">{renderLogisticsAtlanticLine(contactsLogisticsAtlantic)}</a>
        <a href="mailto:Intermodal@dayross.com">{renderLogisticsIntermodalLine(contactsLogisticsIntermodal)}</a>

        <EmptyLine />

        {/*  Flat Bed  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(contactsFlatBedTitle)}</GetInTouchContactsTitle>
        {/* {renderPhoneLine(contactsFlatBedPhone)} */}
        <a href="mailto:flatbed@dayandrossinc.ca">{renderFlatBedEmailLine(contactsFlatBedEmail)}</a>
        <EmptyLine />

        {/*  Sales Inquiries  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(contactsSalesInquireiesTitle)}</GetInTouchContactsTitle>
        {/* {renderPhoneLine(contactsFlatBedPhone)} */}
        <a href="mailto:sales@dayross.com">{renderSalesInquiriesEmailLine(contactsSalesInquiriesEmail)}</a>
        <EmptyLine />

        {/*  General Inquiries  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(contactsGeneralInquiriesTitle)}</GetInTouchContactsTitle>
        <a href="/submit-feedback">
          {' '}
          {renderSubmitQueryEmailLine(contactsGeneralInquiriesSubmitQuery)}
        </a>
        <EmptyLine />

        {/*  Website Support  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(contactsWebsiteSupportTitle)}</GetInTouchContactsTitle>
        <a href="mailto:web.support@dayross.com">{renderWebsiteSupportEmailLine(contactsWebsiteSupportEmail)}</a>
        <EmptyLine />

        {/*  Billing Enquiries  */}
        <GetInTouchContactsTitle>{getCMSFieldValue(billingInquiriesTitle)}</GetInTouchContactsTitle>
        {renderPhoneLine(billingInquiriesPhone)}
        <a href="mailto:invres@dayandrossinc.ca">{renderBillingEnquiriesEmailLine(billingInquiriesEmail)}</a>
        <EmptyLine />
      </div>
    );
  };

  const renderGetInTouchContacts = () => (
    <GetInTouchContactsContainer $tablet={12} $mobile={12}>
      {renderCustomerCareContacts()}
    </GetInTouchContactsContainer>
  );

  const renderGetInTouchPane = () => (
    <GetInTouchPane>
      <GetInTouchContainer>
        <GetInTouchTitle $mobile={12} $desktop={12} $tablet={12} />
        {renderGetInTouchContacts()}
        <GetInTouchFieldsContainer $mobile={12} $tablet={6} />
      </GetInTouchContainer>
    </GetInTouchPane>
  );

  return renderGetInTouchPane();
};

GetInTouch.propTypes = {
  reason: PropTypes.string,
  cmsFields: PropTypes.object,
};

export default GetInTouch;

export function ReasonDataItem(name, reason) {
  this.name = name;
  this.reason = reason;
}

